var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`si-center__datetime ${_vm.$mq}`]},[_c('div',{staticClass:"si-center__date"},[_c('r-text',[_vm._v(_vm._s(_vm.date))])],1),_c('div',{staticClass:"si-center__time"},[_c('r-text',{attrs:{"size":24}},[_vm._v(" "+_vm._s(_vm.time)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }